import { FiX } from "react-icons/fi";

import { ChipList, StatusBadge } from "@/app/library/components/molecules";
import type { Tenant } from "@/app/tenants/utils";
import { Button } from "@/core/ui/atoms";
import { AdminMiniList, AdminMiniRow, Banner } from "@/core/ui/molecules";
import { DrawerTemplate } from "@/core/ui/templates";

type TenantDetailDrawerProps = {
  readonly onClose: () => void;
  readonly tenant: Tenant;
};

export function TenantDetailDrawer({
  onClose,
  tenant,
}: TenantDetailDrawerProps) {
  const packs = getTenantPacks(tenant);

  return (
    <DrawerTemplate
      content={
        <div>
          <AdminMiniList>
            <AdminMiniRow>
              <strong>Owner</strong>
              <span>{tenant.owner}</span>
            </AdminMiniRow>
            <AdminMiniRow>
              <strong>Status</strong>
              <StatusBadge status={tenant.status} />
            </AdminMiniRow>
            <AdminMiniRow>
              <strong>Installed Packs</strong>
              <ChipList values={packs} />
            </AdminMiniRow>
            <AdminMiniRow>
              <strong>Users</strong>
              <span>{tenant.users}</span>
            </AdminMiniRow>
            <AdminMiniRow>
              <strong>Billing</strong>
              <span>{tenant.billing}</span>
            </AdminMiniRow>
          </AdminMiniList>
          <Banner tone="ok">
            <strong>Installed at creation:</strong> atomic · no partial success.
          </Banner>
        </div>
      }
      footer={
        <>
          <Button>Reset Owner Password</Button>
          <Button
            variant={tenant.status === "suspended" ? "primary" : "danger"}
          >
            {tenant.status === "suspended" ? "Reactivate" : "Suspend"}
          </Button>
        </>
      }
      header={
        <div className="flex w-full items-start justify-between gap-3">
          <div>
            <h2 className="text-lg font-extrabold leading-snug text-ink">
              {tenant.name}
            </h2>
            <p className="mt-1 text-[13px] text-ink-muted">
              {tenant.plan} · {tenant.vertical}
            </p>
          </div>
          <button
            aria-label="Close drawer"
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-control border-0 bg-transparent text-ink-subtle transition-colors hover:bg-gray-100 hover:text-ink"
            onClick={onClose}
            type="button"
          >
            <FiX aria-hidden="true" className="h-5 w-5" />
          </button>
        </div>
      }
    />
  );
}

function getTenantPacks(tenant: Tenant) {
  if (tenant.vertical === "HVAC") {
    return ["General Service Pack", "HVAC Starter Pack"];
  }
  if (tenant.vertical === "Facility Mgmt") {
    return ["General Service Pack", "Facility Starter Pack"];
  }
  if (tenant.vertical === "Telco") {
    return ["General Service Pack"];
  }
  return ["General Service Pack"];
}
